import {
  AhTestosteronePanelConsultationUpsell,
  AhWellnessPanelConsultationUpsell,
  BiotinConsultationUpsell,
  ComprehensiveHealthPanelConsultationUpsell,
  FreeTestosteronePanelConsultationUpsell,
  Glp1BoosterConsultationUpsell,
  InjectableTrtAndHcgUpsellConsultationUpsell,
  InjectableTrtConsultationUpsell,
  LevonorgestrelConsultationUpsell,
  MensIntimateWashConsultationUpsell,
  MetforminExtendedReleaseTrtConsultationUpsell,
  MetforminTrtConsultationUpsell,
  OndansetronDissolvableTabletTrtConsultationUpsell,
  OndansetronPillTrtConsultationUpsell,
  OralFinasterideConsultationUpsell,
  OralMinoxidilConsultationUpsell,
  OralTrtAndEnclomipheneUpsellConsultationUpsell,
  OvernightShippingConsultationUpsell,
  PeptideBPC157ConsultationUpsell,
  PeptideCJC1295IpamorelinConsultationUpsell,
  PeptideGHKCuConsultationUpsell,
  PriorityProcessingConsultationUpsell,
  ProbioticsConsultationUpsell,
  SemaglutideInjectable0_5mgConsultationUpsell,
  SemaglutideInjectable1_7mgConsultationUpsell,
  SemaglutideInjectable1mgConsultationUpsell,
  SemaglutideInjectable2_5mgConsultationUpsell,
  SemaglutideOral5mgConsultationUpsell,
  SemaglutideOral12mgConsultationUpsell,
  SildenafilConsultationUpsell,
  TadalafilConsultationUpsell,
  TirzepatideInjectable5mgConsultationUpsell,
  TirzepatideInjectable7_5mgConsultationUpsell,
  TirzepatideInjectable10mgConsultationUpsell,
  TirzepatideInjectable12_5mgConsultationUpsell,
  TirzepatideInjectable15mgConsultationUpsell,
  TirzepatideOral4mgConsultationUpsell,
  TirzepatideOral5mgConsultationUpsell,
  TopicalMinoxidilConsultationUpsell,
  TrtAndEnclomipheneConsultationUpsell,
  TrtAndHcgConsultationUpsell,
  TrtGelAndEnclomipheneUpsellConsultationUpsell,
  VitaminB12SupplementConsultationUpsell,
  VitaminDSupplementConsultationUpsell,
} from '@data/consultation-request-upsells';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Pharmacy } from '@enums/pharmacies';
import { Sites } from '@enums/sites';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the Stallion site, both in production and local environment.
 */
export const stallionCommonEnvironment = {
  site: Sites.Stallion,
  domain: 'Stallion.com',
  siteId: '20',
  faviconFile: 'stallion-favicon.ico',
  phone: '',
  email: 'support@stallion.com',
  businessHours: 'Monday - Sunday 8 a.m. - 8 p.m. (Central Standard Time - CST)',
  allowedRoutes: [
    '/null',
    '/order',
    '/order-complete.php',
    '/choose-a-lab',
    '/consultation/choose-a-lab',
    '/consultation/glp-1/request',
    '/consultation/glp-1-renewal/request',
    '/consultation/alleviate-nausea-and-vomiting',
    '/consultation/replenish-your-good-bacteria',
    '/consultation/be-prepared-for-the-unexpected',
    '/consultation/need-a-doctors-note',
    '/consultation/prevent-vitamin-b12-deficiency',
    '/consultation/maximize-your-glp-1-results',
    '/consultation/upload-consult-attachments',
    '/consultation/payment-info',
    '/consultation/schedule-consultation',
    '/consultation/wellness-panel',
    '/glp-1/consultation-request-completed',
    '/glp-1-renewal/consultation-request-completed',
    '/consultation/submission-error',
    '/consultation/ed/request',
    '/ed/consultation-request-completed',
    '/consultation/peptide-therapy',
    '/consultation/testosterone-therapy',
    '/consultation/vitamin-d-supplement',
    '/consultation/sexual-performance',
    '/consultation/metformin',
    '/consultation/metformin/request',
    '/metformin/consultation-request-completed',
    '/consultation/biotin',
    '/consultation/hair-loss-treatment',
    '/consultation/comprehensive-health-panel',
    '/consultation/expedited-shipping',
    '/consultation/mens-intimate-wash',
    '/consultation/trt/request',
    '/trt/consultation-request-completed',
    '/consultation/peptide/request',
    '/peptide/consultation-request-completed',
    '/peptide-ws/consultation-request-completed',
    '/consultation/peptide-ws/request',
    '/peptide-ws-renewal/consultation-request-completed',
    '/consultation/peptide-ws-renewal/request',
    '/peptide-gs/consultation-request-completed',
    '/consultation/peptide-gs/request',
    '/peptide-gs-renewal/consultation-request-completed',
    '/consultation/peptide-gs-renewal/request',
    '/peptide-bpc-157/consultation-request-completed',
    '/consultation/peptide-bpc-157/request',
    '/peptide-bpc-157-renewal/consultation-request-completed',
    '/consultation/peptide-bpc-157-renewal/request',
    '/peptide-ghk-cu/consultation-request-completed',
    '/consultation/peptide-ghk-cu/request',
    '/peptide-ghk-cu-renewal/consultation-request-completed',
    '/consultation/peptide-ghk-cu-renewal/request',
    '/peptide-tb-500/consultation-request-completed',
    '/consultation/peptide-tb-500/request',
    '/peptide-tb-500-renewal/consultation-request-completed',
    '/consultation/peptide-tb-500-renewal/request',
    '/peptide-cjc-1295/consultation-request-completed',
    '/consultation/peptide-cjc-1295/request',
    '/peptide-cjc-1295-renewal/consultation-request-completed',
    '/consultation/peptide-cjc-1295-renewal/request',
    '/peptide-pt-141/consultation-request-completed',
    '/consultation/peptide-pt-141/request',
    '/peptide-pt-141-renewal/consultation-request-completed',
    '/consultation/peptide-pt-141-renewal/request',
    '/consultation/peptide-renewal/request',
    '/peptide-renewal/consultation-request-completed',
    '/consultation/trt-renewal/request',
    '/trt-renewal/consultation-request-completed',
    '/consultation/hair-loss/request',
    '/hair-loss/consultation-request-completed',
    '/consultation/priority-processing',
  ],
  enablePayLater: false,
  enableBitPay: false,
  enableGiftCard: true,
  enableBusinessAccounts: false,
  applePayLabel: 'Analyte Health',
  order: {
    minAgeAllowed: 18,
    showCancellationPolicy: false,
    navigateToOrderAddressRoute: false,
    shouldShowPhoneFieldOnOrderRoute: true,
    hasPhysicianFee: false,
    physicianFeeInCents: 0,
    forceEmailResults: true,
    isPartnerTestingAllowed: false,
    orderPaymentFormLayout: 'stacked',
    enableOrderUpgrade: false,
    enableDynamicOrderUpgrade: false,
    enableTosOnOrderPage: true,
    stdPanelWithMycoplasmaTestId: 3162,
    abTestsWithMycoplasmaTestId: [3377, 3379, 3376],
    comprehensiveWellnessPanelId: 3381,
    isFemaleCondomUpsellAllowed: false,
    triggerFemaleCondomUpsellConsultation: false,
    skipUpsellsForBusinessAccounts: false,
    orderSummary: {
      allowEditingCart: false,
      editCartButtonText: 'Edit',
      displayCartSummaryTableHeaders: false,
      testsPrefix: 'Medication Online',
      showCouponCode: false,
      displayFindTestsModal: false,
    },
    orderComplete: {
      displaySisterSiteBanner: false,
      testOrderedWording: {
        single: 'Preferred Medication/Treatment',
        plural: 'Preferred Medications/Treatments',
      },
    },
  },
  maxAgeAllowed: 81,
  minimumNameLength: 2,
  disableSchedulingRedirectForTreatmentTypes: [ConsultationTreatmentTypes.Trt, ConsultationTreatmentTypes.TrtRenewal],
  consultation: {
    deliveryPharmacyId: Pharmacy.TAHA,
    lastPeriodQuestionId: '97',
    erectileDysfunctionMedicationQuestionId: '234',
    offersEdTreatmentUpsell: false,
    highBloodPressureQuestionId: '228',
    breastfeedingQuestionIds: ['31', '82'],
  },
  ngFindalab: {
    findalabMapId: '8f1673661122dda0',
    searchEndpoint: '/labs/nearPostalCode',
    filterByStates: null,
    inHomeCollectionAllowed: true,
    inHomeCollectionCostInCents: 7500,
    inHomeCollectionProviderIds: [1, 2],
    showPhone: false,
    filterByTestAndSite: true,
    getNetworksFromTests: false,
    verifyTestsCanBeOrdered: false,
    validateSelectedLabNetwork: false,
    searchTitle: 'Find a Lab',
    searchDescription: 'Please choose a nearby lab for your testing.',
    pharmacySearchDescription:
      'Please choose a nearby pharmacy where our clinician can send your prescription once they have reviewed your medical information.',
    locateMsg: 'Use my current location',
    labButtonText: 'Choose This Lab',
    searchButtonText: 'Find',
    showSearchIcon: false,
    labIconClass: 'fa fa-arrow-right',
    searchMessageNoResults:
      'Oops! Sorry, we could not find any labs near that location. Please try your search again with a different or less specific address.',
    inputGroup: {
      container: '',
      field: null,
      button: '',
    },
    resultsZoom: 12,
    choosePharmacySearchTitle: 'Enter Your Location',
    showDayOfWeekFilter: false,
  },
  titles: {
    order: 'Checkout - Stallion',
    consultationRequest: 'Questionnaire - Stallion',
    headlineCheckoutScheduled: '',
    step1Title: 'Find a Lab',
    selectedCenterLabel: 'Lab',
    orderPageHeader: {
      title: "You're almost <strong>Done!</strong>",
      subtitle: 'We just need a few more details before determining your diagnosis.',
    },
    scheduledConsultationRequest: {
      title: 'Clinician Phone Consultation Needed',
      calendarDetails:
        'To ensure compliance with Telehealth regulations in your state, we must arrange a brief phone consultation with one of our clinicians before prescribing medication. This consultation is provided at no additional cost to you.',
      phoneNumberDetails: 'A Clinician will call you at',
      availabilityDetails:
        "Typically, our clinicians call earlier than the anticipated window, so there's no need to be concerned if your appointment appears to be scheduled further than expected.",
    },
  },
  buttons: {
    checkout: 'Place Order',
    selectedCenterChange: 'Change Lab',
  },
  styles: {
    metaThemeColor: '#edede9',
    chooseAPharmacy: {
      labButtonClass: '',
      searchButtonClass: '',
      googleMapsLabMarkerFillColor: '',
      googleMapsRecommendedMarkerFillColor: '',
      googleMapsMarkerHoverFillColor: '',
    },
    consultationRequest: {
      headlineClass: 'column is-flex is-justify-content-center pt-5 pb-0 has-text-weight-semibold',
    },
    healthLabsCoupon: {
      buttonColor: 'secondary-orange',
    },
    orderCompleteInstructions: {
      cardContentClass: '',
    },
    orderBetterLab: {
      orderPlaceNotificationClass: 'is-warning',
      currentTestCenterNotificationClass: 'is-info',
      keepCurrentLabButtonClass: 'is-uppercase',
      keepCurrentLabButtonColor: 'secondary-orange',
    },
    testCenter: {
      labButtonClass: '',
      searchButtonClass: 'is-secondary-orange has-text-white',
      googleMapsLabMarkerFillColor: '#fa676b',
      googleMapsRecommendedMarkerFillColor: '#fdd8d9',
      googleMapsMarkerHoverFillColor: '#f84f55',
    },
  },
  shopperApproved: {
    site: 41873,
    token: '88883Qvw',
  },
  consultationRequestUpsells: {
    [UpsellSlugs.Levonorgestrel]: LevonorgestrelConsultationUpsell,
    [UpsellSlugs.Probiotics]: ProbioticsConsultationUpsell,
    [UpsellSlugs.MensIntimateWash]: MensIntimateWashConsultationUpsell,
    [UpsellSlugs.VitaminB12Supplement]: VitaminB12SupplementConsultationUpsell,
    [UpsellSlugs.AhWellnessPanel]: AhWellnessPanelConsultationUpsell,
    [UpsellSlugs.Glp1Booster]: Glp1BoosterConsultationUpsell,
    [UpsellSlugs.OvernightShipping]: OvernightShippingConsultationUpsell,
    [UpsellSlugs.OndansetronPill]: OndansetronPillTrtConsultationUpsell,
    [UpsellSlugs.OndansetronDissolvableTablet]: OndansetronDissolvableTabletTrtConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable0_5mg]: SemaglutideInjectable0_5mgConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable1mg]: SemaglutideInjectable1mgConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable1_7mg]: SemaglutideInjectable1_7mgConsultationUpsell,
    [UpsellSlugs.SemaglutideInjectable2_5mg]: SemaglutideInjectable2_5mgConsultationUpsell,
    [UpsellSlugs.SemaglutideOral5mg]: SemaglutideOral5mgConsultationUpsell,
    [UpsellSlugs.SemaglutideOral12mg]: SemaglutideOral12mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable5mg]: TirzepatideInjectable5mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable7_5mg]: TirzepatideInjectable7_5mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable10mg]: TirzepatideInjectable10mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable12_5mg]: TirzepatideInjectable12_5mgConsultationUpsell,
    [UpsellSlugs.TirzepatideInjectable15mg]: TirzepatideInjectable15mgConsultationUpsell,
    [UpsellSlugs.TirzepatideOral4mg]: TirzepatideOral4mgConsultationUpsell,
    [UpsellSlugs.TirzepatideOral5mg]: TirzepatideOral5mgConsultationUpsell,
    [UpsellSlugs.PeptideGHKCu]: PeptideGHKCuConsultationUpsell,
    [UpsellSlugs.PeptideCJC1295Ipamorelin]: PeptideCJC1295IpamorelinConsultationUpsell,
    [UpsellSlugs.PeptideBPC157]: PeptideBPC157ConsultationUpsell,
    [UpsellSlugs.Metformin]: MetforminTrtConsultationUpsell,
    [UpsellSlugs.MetforminExtendedRelease]: MetforminExtendedReleaseTrtConsultationUpsell,
    [UpsellSlugs.ComprehensiveHealthPanel]: ComprehensiveHealthPanelConsultationUpsell,
    [UpsellSlugs.AhTestosteronePanel]: AhTestosteronePanelConsultationUpsell,
    [UpsellSlugs.InjectableTrt]: InjectableTrtConsultationUpsell,
    [UpsellSlugs.TrtAndHcg]: TrtAndHcgConsultationUpsell,
    [UpsellSlugs.TrtAndEnclomiphene]: TrtAndEnclomipheneConsultationUpsell,
    [UpsellSlugs.InjectableTrtAndHcgUpsell]: InjectableTrtAndHcgUpsellConsultationUpsell,
    [UpsellSlugs.OralTrtAndEnclomipheneUpsell]: OralTrtAndEnclomipheneUpsellConsultationUpsell,
    [UpsellSlugs.TrtGelAndEnclomipheneUpsell]: TrtGelAndEnclomipheneUpsellConsultationUpsell,
    [UpsellSlugs.Sildenafil]: SildenafilConsultationUpsell,
    [UpsellSlugs.Tadalafil]: TadalafilConsultationUpsell,
    [UpsellSlugs.VitaminDSupplement]: VitaminDSupplementConsultationUpsell,
    [UpsellSlugs.TopicalMinoxidil]: TopicalMinoxidilConsultationUpsell,
    [UpsellSlugs.OralMinoxidil]: OralMinoxidilConsultationUpsell,
    [UpsellSlugs.OralFinasteride]: OralFinasterideConsultationUpsell,
    [UpsellSlugs.Biotin]: BiotinConsultationUpsell,
    [UpsellSlugs.FreeTestosteronePanel]: FreeTestosteronePanelConsultationUpsell,
    [UpsellSlugs.PriorityProcessing]: PriorityProcessingConsultationUpsell,
  },
} satisfies Partial<AppEnvironment>;
